import { useMemo } from 'react';
import { useDataTableContext } from './use-server-data-table';

export const useGetFilterLabels = (filterNames: string[]) => {
  const { table, filterFields } = useDataTableContext() ?? {};

  return useMemo(() => {
    if (!table || !filterFields) {
      return { labelsMap: {}, flatLabels: [] };
    }
    const fieldMap = new Map(filterFields.map((f) => [f.value, f]));

    const labelsMap: Record<string, string[]> = {};
    const flatLabels: string[] = [];

    for (const name of filterNames) {
      const column = table.getColumn(name);
      const selectedValues = column?.getFilterValue() as string[] | undefined;
      const field = fieldMap.get(name);

      if (!selectedValues || !field?.options) {
        labelsMap[name] = [];
        continue;
      }

      const optionMap = new Map(
        field.options.map((opt) => [opt.value, opt.label])
      );

      const labels = selectedValues.map((val) => optionMap.get(val) ?? val);

      labelsMap[name] = labels;

      for (const label of labels) {
        flatLabels.push(`${label}`);
      }
    }

    return { labelsMap, flatLabels };
  }, [filterNames, table, filterFields]);
};
